import { module } from "angular";
import { map } from "rxjs/operators";

import type { Observable } from "rxjs";

import type { IHttpService } from "App/Modules/Services";

import { forEach } from "lodash";
import type { ICompany, IResponse, ISiteSlim } from "App/Modules/Models";

import { SitesRepository } from "App/Modules/Repositories/Site/SitesRepository";
import type { ICompaniesRepository } from "./ICompaniesRepository";

export default class CompaniesRepository implements ICompaniesRepository {
    public static $inject: string[] = ["mmHttpService"];

    constructor(private readonly httpService: IHttpService) {}

    public getAllCompanies(partnerId?: string, search?: string): Observable<IResponse<ICompany[]>> {
        const params = {};
        if (partnerId) {
            Object.assign(params, { partnerId });
        }
        if (search) {
            Object.assign(params, { search });
        }
        return this.httpService.get<ICompany[]>("companies", params);
    }

    public getCompany(companyId: string): Observable<IResponse<ICompany>> {
        return this.httpService.get<ICompany>(`companies/${companyId}`);
    }

    public getSitesForCompany(companyId: string): Observable<IResponse<ISiteSlim[]>> {
        return this.httpService.get<ISiteSlim[]>(`companies/${companyId}/sites`).pipe(
            map((response: IResponse<ISiteSlim[]>) => {
                if (!response.data) {
                    return response;
                }

                forEach(response.data, (site) => {
                    SitesRepository.enhanceSite(site);
                });

                return response;
            }),
        );
    }

    public addCompany(
        company: Partial<Omit<ICompany, "name" | "partner">> & Pick<ICompany, "name" | "partner">,
    ): Observable<IResponse<ICompany>> {
        return this.httpService.post<ICompany>("companies", company);
    }

    public mergeCompany(companyToDeleteId: string, companyToMergeId: string): Observable<IResponse<void>> {
        return this.httpService.delete(`companies/merge/${companyToDeleteId}/with/${companyToMergeId}`);
    }

    public patchCompany(companyId: string, company: ICompany): Observable<IResponse<ICompany>> {
        return this.httpService.patch<ICompany>(`companies/${companyId}`, company);
    }

    public deleteCompany(companyId: string): Observable<IResponse<void>> {
        return this.httpService.delete(`companies/${companyId}`);
    }
}

module("mmRepositories").service("mmCompaniesRepository", CompaniesRepository);
